var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file"},on:{"change":_vm.handleFileChange}}),_c('b-button',{on:{"click":_vm.handleProcessClick}},[_vm._v("\n    Process\n  ")]),(_vm.objs && Array.isArray(_vm.objs))?_c('h5',[_vm._v("\n    "+_vm._s(_vm.objs.length)+" items to process\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }